function isOperatorType(value: any): value is OperatorType {
    return ['Eq', 'Like', 'More', 'MoreOrEq', 'Less', 'LessOrEq', 'NotEq'].includes(value);
}

function isGridColumnFilter(obj: any): obj is IGridColumnFilter {
    return typeof obj === 'object' &&
        obj !== null &&
        typeof obj.name === 'string' &&
        obj.value !== undefined &&  // any, но не undefined
        isOperatorType(obj.operator) &&
        (obj.invisible === undefined || typeof obj.invisible === 'boolean');
}

export function isGridFilter(obj: any): obj is IGridFilter {
    return typeof obj === 'object' &&
        obj !== null &&
        typeof obj.pageNumber === 'number' &&
        typeof obj.numberPerPage === 'number' &&
        (obj.fieldOrderBy === undefined || typeof obj.fieldOrderBy === 'string') &&
        (obj.orderDesc === undefined || typeof obj.orderDesc === 'boolean') &&
        Array.isArray(obj.columnFilters) &&
        obj.columnFilters.length >= 0 &&
        obj.columnFilters.every(isGridColumnFilter) &&
        (obj.paramFilter === undefined || typeof obj.paramFilter === 'object') &&
        (obj.expression === undefined || typeof obj.expression === 'string');
}